import React, {createContext, PropsWithChildren, useContext, useEffect, useState} from "react";
import {Organization} from "myfitworld-model";
import {firestore} from "../firebase";

const OrganizationsProviderContext = createContext<{
  organizations: Array<Organization> | null,
}>({organizations: null});

export const OrganizationsProvider = ({children}: PropsWithChildren<any>) => {
  const [organizations, setOrganizations] = useState<Array<Organization> | null>(null);

  useEffect(() => {
    const unsubscribe = firestore.collection("/organizations").onSnapshot(
      (snapshot) => {
        const orgs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as Organization[];
        setOrganizations(orgs);
      },
      (error) => {
        console.error("Error fetching organizations:", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  return <OrganizationsProviderContext.Provider value={{organizations: organizations}}>
    {children}
  </OrganizationsProviderContext.Provider>
}


export const useOrganizationsProvider = () => {
  const context = useContext(OrganizationsProviderContext);

  if (context === undefined) {
    throw new Error(
      'useOrganizationsProvider must be used within an OrganizationsProvider'
    );
  }
  return context;
};
